import React, { useEffect, useState } from 'react';
import { SectionContainer } from '../SectionContainer';

export const CatNats = ({data, catnatsList, openMedia}) => {
    const [selectedItem, setSelectedItem] =  useState(null);

    const formatDate = (dateString) => {
        let date = new Date(dateString);
        return `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`
    }

    useEffect(() => {
        if(data && catnatsList){
            data.items[0].alternativeMap = {
                title: "Le détail des arrêtés",
                type: "table",
                tableHeaders: ["Code", "Libellé", "Date de publication au JO"],
                entries: [...catnatsList.map(i => [i.code, i.libelle, formatDate(i.datePubJo)])]
            }
           setSelectedItem(data.items[0]);
        }
    },[data, catnatsList])

    return (
        <section className="main-container">
            {selectedItem &&
                <div className="content">
                    <div className="submenu-container"> 
                        <h1>Catastrophes naturelles</h1>
                    </div>
                    <div className="subcontent">
                        <SectionContainer selectedItem={selectedItem} openMedia={openMedia}/>
                    </div>
                </div>
            }
        </section>
    )
}